import produce from "immer";
import reducerUtils from "../../../../store/reducerUtils";
import VendorKeyActions from "./VendorKeyActions";

const initialState = {
  data: {
    list: null,
    listCounter: 0,

    key: null,
  },
};

export const vendorKeySelectors = {
  getList: (state) => state.vendorKeys.data.list,
  getListCounter: (state) => state.vendorKeys.data.listCounter,
  getKey: (state) => state.vendorKeys.data.key,
};

const onLoadList = produce((draft, action) => {
  draft.data.list = action.list;
});

const onListChanged = produce((draft) => {
  draft.data.listCounter++;
});

const onKeyLoaded = produce((draft, action) => {
  const obj = action.key;
  draft.data.key = obj;
});

const onKeyUpdated = produce((draft, action) => {
  const obj = action.key;
  draft.data.key = obj;
  draft.data.listCounter++;
});

const handlers = {
  [VendorKeyActions.LIST_LOADED]: onLoadList,
  [VendorKeyActions.LIST_CHANGED]: onListChanged,
  [VendorKeyActions.LOADED]: onKeyLoaded,
  [VendorKeyActions.UPDATED]: onKeyUpdated,
};

const vendorKeyReducer = reducerUtils.createReducer(initialState, handlers);

export default vendorKeyReducer;
